import { render } from "./DashboardRegistries.vue?vue&type=template&id=6ffa29ea"
import script from "./DashboardRegistries.vue?vue&type=script&lang=js"
export * from "./DashboardRegistries.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__